import router from '..'

export default function rbacDelivery () {
  const role = localStorage.getItem('role')
  // Permitir acceso a roles 1 (super admin) y 2 (admin)
  if (role !== '1' && role !== '2') {
    router.push({ name: 'UnauthorizedView' })
    return false
  }
  return true
}
